import { useQuery } from '@tanstack/react-query';

import { CARD_TYPES } from 'src/features/cards/types/card';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PricingPlan } from 'src/features/pricingPlans/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE_NORMAL = '/parkings/:parkingId/pricing-plans/normal/';
const RESOURCE_MEMBERSHIP = '/parkings/:parkingId/pricing-plans/membership/';

type ListPricingPlansQueryFnType = typeof listNormalPricingPlans;

interface ListPricingPlansDTO extends ListDTO {
    parkingId: string;
}

const listMembershipPricingPlans = ({
    parkingId,
    ...params
}: ListPricingPlansDTO): Promise<ListResponseSmartParkAPI<PricingPlan>> => {
    return axios.get(formatResourcePath(RESOURCE_MEMBERSHIP, { parkingId }), { params });
};

const listNormalPricingPlans = ({
    parkingId,
    ...params
}: ListPricingPlansDTO): Promise<ListResponseSmartParkAPI<PricingPlan>> => {
    return axios.get(formatResourcePath(RESOURCE_NORMAL, { parkingId }), { params });
};

interface UseListPricingPlans extends ListPricingPlansDTO {
    config?: QueryConfig<ListPricingPlansQueryFnType>;
    cardType: CARD_TYPES;
}

const useListPricingPlans = ({ config, cardType, ...params }: UseListPricingPlans) =>
    useQuery({
        queryKey: ['pricing-plans', cardType, ...Object.values(params)],
        queryFn: async () => {
            if (cardType === CARD_TYPES.NORMAL) return await listNormalPricingPlans(params);
            return await listMembershipPricingPlans(params);
        },
        ...config,
    });

export {
    RESOURCE_MEMBERSHIP,
    RESOURCE_NORMAL,
    listMembershipPricingPlans,
    listNormalPricingPlans,
    useListPricingPlans,
};
